import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProjectListHandlerService {
  shouldListBeDisabled = signal(false);
}
